module.exports = __webpack_public_path__ + "img/resized_image.607fef8e.png";